// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Services_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/services/get/{id}.
 *
 * Returns a single active/inactive service record. Wire shape:
 * `dados: Services_GetRow`.
 *
 * @see Services_GetRow
 * @see Services::get()
 */
import type { Services_GetRow } from './Services_GetRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Services_GetResponseDados = Services_GetRow;

export type Services_GetResponse = ApiResponse<Services_GetResponseDados>;

registerResponseContract('Services_GetResponse', {
  so_service_id:            { type: 'number',  required: true },
  so_service_category_id:   { type: 'number',  required: true },
  so_service_name:          { type: 'string',  required: true },
  so_service_description:   { type: 'string',  required: false },
  so_service_color:         { type: 'string',  required: false },
  so_service_default_price: { type: 'number',  required: true },
  so_service_active:        { type: 'number',  required: true },
  so_service_created_at:    { type: 'string',  required: false },
})
